import React, {ComponentProps} from 'react';
import useDebounce from 'react-use/lib/useDebounce';

import {Textinput} from 'client/common/components/lego';

interface DebouncedTextInputProps extends ComponentProps<typeof Textinput> {
    callback: () => void;
}

const DEBOUNCE_WAIT = 1000;


export default function DebouncedTextInput(props: DebouncedTextInputProps) {

    const {callback, ...rest} = props;

    useDebounce(() => {
        callback();
    }, DEBOUNCE_WAIT, [callback]);

    return (
        <Textinput
            {...rest}
        />
    );
}
